import { render, staticRenderFns } from "./detail-drawer.vue?vue&type=template&id=26e8f60b&scoped=true&"
import script from "./detail-drawer.vue?vue&type=script&lang=ts&"
export * from "./detail-drawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e8f60b",
  null
  
)

export default component.exports